export const splitCamelCase = (value: string) => value?.replace(/([a-z])([A-Z])/g, '$1 $2');

export const capitalizeWords = (value: string) => value?.split(' ')?.map((word: string) => word[0].toLocaleUpperCase() + word.slice(1))?.join(' ');
